module.exports = __webpack_public_path__ + "img/product2-1.ef3e9979.png";